/* unplugin-vue-components disabled */
import {markRaw} from 'vue'
import TrackerSegment from './tracker-segment.vue'
import TrackerSlider from './tracker-slider.vue'
import TrackerButtongroup from './tracker-buttongroup.vue'
import TrackerTextarea from './tracker-textarea.vue'
import $tracker from 'stores/tracker'
import $companies from 'stores/companies'
import {COMPANY_ALERTS, COMPANY_TYPES} from 'consts/tracker'
import {sliderFocus} from '../pulse-defs'
import {CompanySearch} from 'components/search-dropdown'

export default {
  components: {CompanySearch, TrackerSegment, TrackerSlider, TrackerButtongroup, TrackerTextarea},
  props: {
    linkedinId: {
      type: String,
      default: undefined
    }
  },
  emits: ['cancel'],
  data() {
    return {
      TYPES: markRaw(COMPANY_TYPES),
      ALERTS: markRaw(COMPANY_ALERTS),
      saving: false,

      website_url: undefined,
      tracker_type: 'account',
      tracker_focus: 'balanced',
      tracker_alerts: 'all',
      focus_on: undefined,
      company: undefined
    }
  },
  computed: {
    tracker_data(){
      const data =  {
        linkedin_id: this.company?.linkedin_id,
        shared_company_id: this.company?.shared_company_id,
        tracker_type: this.tracker_type,
        tracker_focus: this.tracker_focus,
        tracker_alerts: this.tracker_alerts,
        focus_on: this.focus_on,
        company_name: this.company?.name,
      }
      return data
    },
    slider_focus: sliderFocus(),
    focus_text() {
      return !!this.focus_on?.trim()
    },
    can_save() {
      return !!this.company?.linkedin_id
    },
  },
  mounted() {
    if (this.linkedinId) {
      this.$refs.linkedin.setValue(`https://linkedin.com/company/${this.linkedinId}`)
    }
    this.$refs.linkedin.focus()
  },
  beforeUnmount() {
    $companies.abortAll()
  },
  methods: {
    async onSave() {
      this.saving = true
      try {
        const company = await $companies.newCompany(this.tracker_data)
      
        const tracker_data = {
          id: company.id,
          name: company.name,
          type: company.tracker_type,
          logo_url: company.logo_url,
          shared_company_id: company.shared_company_id
        }
      
        $tracker.pinManually(tracker_data)
        this.$dispatch('edit-company', {company_id: tracker_data.id})
      } 

      catch (err) {
        if (err.http_code === 409) {
          const msg = err.json?.name ? `<b>${err.json.name}</b>` : 'this company'
          $utils.toasts.success(`You are already tracking <b>${msg}</b>.`)
          return
        } 
        if (err.http_code === 461) {
          $utils.toasts.success('It seems that this company does not exist. Please try again.')
          return
        }
        throw err
      }

      finally {
        this.saving = false
        this.$dispatch('save', this.tracker_data)
      }
    }
  }
}
